<template>
  <van-action-sheet :value="value" @input="val=>this.$emit('input',val)" title="图形验证码" style="height:200px;" @close="handleClose">
    <van-form class="img-validator-content" @submit="handleSureImg">
      <van-field v-model="code" name="code" label="验证码" placeholder="请输入图形验证码" :rules="[{ required: true, message: '' }]">
        <template #button>
          <img :src="img" alt="" class="imgCode" v-if="img" @click="handleGetImgValidatorApi">
        </template>
      </van-field>
      <div class="btn">
        <van-button class="button" round type="primary" size="large" block native-type="submit">确定</van-button>
      </div>
    </van-form>
  </van-action-sheet>
</template>

<script>
export default {
  name: "ImgValidator",
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    img: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      code: ''
    };
  },
  methods: {
    // 验证图片 验证码
    handleSureImg(values) {
      if (!values.code) {
        this.$notify({ color: '#F4111F', background: '#FFEC70', message: '请填写图形验证码' })
        return false
      }
      // 验证图形验证码正确 与否
      this.$emit('sure', { code: values.code })
    },
    // 关闭图形验证码
    handleClose() {
      console.log('close');
      this.code = ''
      this.$emit('close', false)
    },
    // 重新发送 图形验证码
    handleGetImgValidatorApi() {
      this.$emit('sendImgCode')
    }
  },
};
</script>
<style lang="scss" scoped>
.img-validator-content {
  padding: 10px;
  position: relative;
  .btn {
    width: 261px;
    margin: 16px auto;
    .button {
      border: none;
      width: 261px;
      height: 47px;
      background: linear-gradient(180deg, #ff6075 0%, #f4111f 100%);
      border-radius: 24px;
    }
  }
}
.imgCode {
  width: 60px;
  height: 26px;
}
</style>